import { MesssageFilters } from '../models/Message'
import { MessagesSectionEnum } from '../models/enum'

export const getResponsibleQueryString = (
  responsibleId: string | null
): string => {
  return responsibleId ? `&responsibleUserId=${responsibleId}` : ''
}

export const getUnitResidentQueryString = (
  residentId: string | null
): string => (residentId ? `&navneregisterIds=${residentId}` : '')

export const getUnitQueryString = (unitId: string | null): string =>
  unitId ? `&unitId=${unitId}` : ''

export const getSearchTextQueryString = (
  searchText: string | null | undefined
): string => (searchText ? `&searchText=${searchText}` : '')

export const getFilterQueryParams = (filters: MesssageFilters) => {
  const { unitId, responsibleId, residentId, searchText } = filters
  const queryParams = [
    getUnitQueryString(unitId),
    getResponsibleQueryString(responsibleId),
    getUnitResidentQueryString(residentId),
    getSearchTextQueryString(searchText),
  ]
  return queryParams.join('')
}

export const getSectionQueryParams = (section: MessagesSectionEnum) => {
  const archivedQueryParam = `&archivedThreads=${
    section === MessagesSectionEnum.Archived
  }`

  switch (section) {
    case MessagesSectionEnum.UnAnswered:
      return `${archivedQueryParam}&unansweredThreads=true`
    case MessagesSectionEnum.Answered:
      return `${archivedQueryParam}&unansweredThreads=false`
    default:
      return archivedQueryParam
  }
}
